(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-discription-tabs"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const tabs = document.querySelectorAll('.tab-item');
  const panes = document.querySelectorAll('.tab-pane');

  function isMobile() {
    return window.innerWidth <= 786;
  }

  // Fallback: if no desktop tab is active (e.g. the first block is hidden),
  // activate the first rendered one so content is visible without a click.
  const desktopTabs = document.querySelectorAll('.tabs-desktop .tab-item');
  if (desktopTabs.length && !document.querySelector('.tabs-desktop .tab-item.active')) {
    const firstTab = desktopTabs[0];
    const firstPane = document.getElementById(firstTab.getAttribute('data-tab'));
    firstTab.classList.add('active');
    if (firstPane) firstPane.classList.add('active');
  }

  tabs.forEach(tab => {
    tab.addEventListener('click', function() {
      const tabId = this.getAttribute('data-tab');
      const targetPane = document.getElementById(tabId);

      if (isMobile()) {
        // Accordion behavior for mobile
        if (this.classList.contains('active')) {
          // Collapse if already active
          this.classList.remove('active');
          targetPane.classList.remove('active');
        } else {
          // Expand clicked item, collapse others
          tabs.forEach(t => t.classList.remove('active'));
          panes.forEach(p => p.classList.remove('active'));
          this.classList.add('active');
          targetPane.classList.add('active');
        }
      } else {
        // Tab behavior for desktop
        tabs.forEach(t => t.classList.remove('active'));
        panes.forEach(p => p.classList.remove('active'));
        this.classList.add('active');
        targetPane.classList.add('active');
      }
    });
  });

  // Adjust layout on window resize
  window.addEventListener('resize', function() {
    if (!isMobile()) {
      // Ensure first tab is active on desktop if no tab is selected
      if (!document.querySelector('.tab-item.active')) {
        tabs[0].classList.add('active');
        panes[0].classList.add('active');
      }
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadRelatedProductsIntoSection = function() {
  // Look for an element with class 'related-products'
  var relatedProductsSection = document.querySelector('.related-products');
  if (relatedProductsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", relatedProductsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      relatedProductsSection.innerHTML = container.querySelector('.related-products').innerHTML;
      theme.initAnimateOnScroll();
    }
  };
  request.send();
};
// Fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadRelatedProductsIntoSection();
  }
});
// Fetch the products on page load
loadRelatedProductsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
